<template>
	<div>
		<div class="wrapper">
			<form class="login-form" @submit.prevent="submit">
				<div class="login-form_title">{{$t('Войти')}}</div>

				<input type="text" required class="login-form_input" v-model="login" :placeholder="$t('Номер телефона')">
				<input type="password" required class="login-form_input" v-model="password" :placeholder="$t('Пароль')">
				
				<button class="button">{{$t('Войти')}}</button>
				
				<div v-if="error" class="login-form_error">{{$t('Ошибка, повторите позже')}}</div>
			</form>
		</div>
	</div>
</template>

<script>
	export default {
		data: () => ({
			login: '',
			password: '',
			error: false,
			auth: window.auth
		}),
		created() {
			if (this.auth.msisdn) {
				this.$router.push({
					name: 'home'
				}) 
			}
		},
		methods: {
			async submit() {
				let data = await this.axios.post('/games/login', {
					phone: this.login,
					password: this.password
				});
				
				if (data.data.status === 'error') {
					this.error = true;
				} else if (data.data.status === 'ok') {
					this.$router.push({
						name: 'home'
					})
				}
			}
		}
	}
</script>

<style scoped>

</style>
